<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>{{'Amount' | localize}}</th>
          <th v-if="dateIs">{{'Date' | localize}}</th>
          <th v-if="Is">{{'Category' | localize}}</th>
          <th v-if="Is">{{'Type' | localize}}</th>
          <th>{{'Open' | localize}}</th>
          <th>{{'Delete' | localize}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(record, index) in HistoryRecords" :key="record.id">
          <td>{{index + 1}}</td>
          <td>{{record.amount | currency}}</td>
          <td v-if="dateIs">{{filterDate(record.date)}}</td>
          <td v-if="Is">{{findCategory(record.categoryId)}}</td>
          <td v-if="record.type === 'outcome' && Is">
            <span class="white-text badge red">{{'Outcome' | localize}}</span>
          </td>
          <td v-else-if="record.type === 'income' && Is">
            <span class="white-text badge green">{{'Income' | localize}}</span>
          </td>
          <td>
            <button
              class="btn-small btn"
              @click="$router.push(`/detail/${record.id}`)"
              v-tooltip="'OpenRecord'"
            >
              <i class="material-icons">open_in_new</i>
            </button>
          </td>
          <td>
            <button
              class="btn-floating btn-small waves-effect waves-light red"
              type="button"
              @click.prevent="recordDelete(record.id)"
            >
              <i class="material-icons">delete</i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.btn-small {
  width: 37px !important;
  height: 36px !important;
  margin-left: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
}

table {
  font-size: 14px;
  transition: all 0.2s linear;
}

@media screen and (max-width: 500px) {
  table {
    font-size: 12px;
    transition: all 0.2s linear;
  }
}
</style>

<script>
import dateFilter from "@/filters/date.filter";

export default {
  name: "CategoryHistory",
  props: ["HistoryRecords", "HistoryCategories"],
  data: () => ({
    width: null,
    dateIs: true,
    Is: true,
    recordDate: null,
    filteredDate: null
  }),
  mounted() {
    this.HistoryRecords.reverse();

    this.width = window.innerWidth;
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
  },
  watch: {
    width() {
      if (this.width > 700) {
        this.filteredDate = dateFilter(this.recordDate, "date");
        this.dateIs = true;
      } else if (this.width <= 700) {
        this.dateIs = false;
      }
      if (this.width <= 450) {
        this.Is = false;
      } else if (this.width > 450) {
        this.Is = true;
      }
    }
  },
  methods: {
    filterDate(recordDate) {
      this.recordDate = recordDate;
      return this.filteredDate;
    },
    findCategory(id) {
      const index = this.HistoryCategories.findIndex(c => c.id === id);
      return this.HistoryCategories[index].title;
    },
    async recordDelete(recordId) {
      this.loading = true;
      await this.$store.dispatch("deleteRecord", recordId);
      await this.$emit("recordDelete");
      this.loading = false;
    },
    updateWidth() {
      this.width = window.innerWidth;
    }
  }
};
</script>